import { Card, CardContent, Stack, Typography, Box } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import CalendarMonth from '@mui/icons-material/CalendarMonth';
import CalendarToday from '@mui/icons-material/CalendarToday';
import Villa from '@mui/icons-material/Villa';

const DemographicInfo = ({ data }) => {
  const { firstName, lastName, suffix, dateOfBirth, age, residentState } = data;
  const isoDateOfBirth = new Date(dateOfBirth);
  const formatedDate = isoDateOfBirth.toLocaleDateString('en-Us', {
    timeZone: 'UTC',
  });

  return (
    <Card variant="outlined">
      <CardContent>
        <Stack direction={'row'} gap={2}>
          <Stack direction={'column'} gap={2}>
            {/* Name */}
            <Box display="flex" alignItems="center">
              <PersonIcon fontSize="sm" color="text.secondary" />
              <Typography sx={{ pl: '.5rem' }} variant="body1">
                Name: {`${firstName} ${lastName} ${suffix}`}
              </Typography>
            </Box>

            {/* Date of Birth */}
            {dateOfBirth && formatedDate !== new Date() && (
              <Box display="flex" alignItems="center">
                <CalendarMonth fontSize="sm" color="text.secondary" />
                <Typography sx={{ pl: '.5rem' }} variant="body1">
                  Date of Birth: {formatedDate}
                </Typography>
              </Box>
            )}
          </Stack>
          <Stack direction={'column'} gap={2}>
            {/* Age */}
            <Box display="flex" alignItems="center">
              <CalendarToday fontSize="sm" color="text.secondary" />
              <Typography sx={{ pl: '.5rem' }} variant="body1">
                Age: {age} yrs
              </Typography>
            </Box>

            {/* Resident State */}
            <Box display="flex" alignItems="center">
              <Villa fontSize="sm" color="text.secondary" />
              <Typography sx={{ pl: '.5rem' }} variant="body1">
                Resident State: {residentState}
              </Typography>
            </Box>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};
export default DemographicInfo;
